import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { jsx as _jsx } from "react/jsx-runtime";
const SalesforceEnrollmentSetting = ({
  flow,
  readOnly,
  settings: {
    classicEnrollmentSettings
  },
  onChange
}) => {
  const trackEvent = useTrackEvent();
  const allowEnrollmentFromMerge = classicEnrollmentSettings && classicEnrollmentSettings.canEnrollFromSalesforce;
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.salesforceEnrollment.title"
    }),
    description: /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "settingsV2.salesforceEnrollment.description_cob",
        objectTypeId: flow.objectTypeId
      })
    }),
    body: /*#__PURE__*/_jsx(UIToggle, {
      readOnly: readOnly,
      checked: !!allowEnrollmentFromMerge,
      onChange: ({
        target: {
          checked
        }
      }) => {
        if (classicEnrollmentSettings) {
          trackEvent(Trackables.WORKFLOW_SETTINGS_INTERACTION, {
            value: `${checked}`,
            subAction: 'salesforce'
          });
          onChange({
            classicEnrollmentSettings: classicEnrollmentSettings.set('canEnrollFromSalesforce', checked)
          });
        }
      }
    })
  });
};
export default SalesforceEnrollmentSetting;